import React from 'react';
import Text from '../Text';
import light from './images/light.svg';
import VideoPlayer from '../VideoPlayer';
import './VideoPlayerCard.less';

type NextSessionCardProps = {
  title?: string;
  description?: string;
  videoUrl?: string;
  href?: string;
  height?: string;
  videoSize: Object;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onHover?: boolean;
};

const TNextSessionCard: React.FC<NextSessionCardProps> = ({
  title,
  description,
  height,
  href,
  onHover,
}) => {
  const [mobile, setMobile] = React.useState(false);

  React.useEffect(() => {
    const windowWidth = window.screen.width;
    if (windowWidth < 1199) {
      setMobile(true);
    }
  });

  const classNames = ['t-video-player-card'];
  if (onHover) {
    classNames.push('cardHover');
  }

  return (
    <div style={{ height: `${height}` }} className={classNames.join(' ')}>
      <div className="t-video-info-wrapper">
        <img src={light} alt="light" />
        <div className="t-video-info-text-wrapper">
          <Text textColor="indicator-caution" level={1} paddingBottom={3} bold>
            {title}
          </Text>
          <Text level={3} rows={2}>
            {description}
          </Text>
        </div>
      </div>
      <div className="t-video-card">
        <VideoPlayer
          href={href}
          width={!mobile ? '12vw' : '230px'}
          height="120px"
        />
      </div>
    </div>
  );
};

export default TNextSessionCard;
